import logo from './logo.svg';
import './App.css';
import {NftGallery} from'./components/NftGallery.js'
function App() {
  return (
    <div>
      <header >
        <h1>CIS233 NFT Gallery</h1>
      </header>
      <NftGallery ownerAddress="0x7BeF8662356116cb436429F47e53322B711F4E42" />
    </div>
  );
}

export default App;
